import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ConfigSettingsService } from '@ebeihilfe/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import accountMenuItems, { AccountMenuItem } from './menu-account-items';

@Component({
  imports: [MatIcon, MatButtonModule, MatDivider, MatMenuModule, RouterLink, TranslateModule],
  standalone: true,
  selector: 'portal-toolbar-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMenuComponent implements OnInit {
  private readonly configService: ConfigSettingsService = inject(ConfigSettingsService);
  public accountMenuItems = signal<AccountMenuItem[]>([]);

  public ngOnInit(): void {
    this.accountMenuItems.set(
      accountMenuItems.filter((item) => item.grantGuard?.(this.configService.appSettings.supportedOAuthGrants) ?? true),
    );
  }
}
